import React from "react"
import useFetchTeamMemberVacationsBucket from "./hooks/useFetchTeamMemberVacationsBucket.hook"
import { DateTime } from "luxon"
import ProgressSpinner from "../../../../components/atoms/misc/ProgressSpinner.atom"
import VacationBucketDaysTable from "../../components/VacationBucketDays/VacationBucketDaysTable.molecule"

export default function TeamMemberVacationsBucketTable({
  teamMemberId,
  workAnniversary,
  periodStartDate,
  periodEndDate,
}) {
  const { bucket, isLoading } = useFetchTeamMemberVacationsBucket({
    teamMemberId,
    workAnniversary,
    periodStartDate,
    periodEndDate,
  })

  const today = DateTime.now()
  const bucketResumeMonths = bucket?.data[0]?.monthsData
  const currentMonthIndex =
    bucketResumeMonths ?
      bucketResumeMonths.findIndex(
        (month) => month.month === today.month && month.year === today.year
      )
    : -1
  const monthToHighlight = currentMonthIndex === -1 ? 0 : currentMonthIndex

  if (isLoading)
    return (
      <div className="flex justify-content-center p-5">
        <ProgressSpinner />
      </div>
    )

  if (!bucket) return null

  return (
    <VacationBucketDaysTable
      bucketDaysInfo={bucket}
      monthToHighlight={monthToHighlight}
      anniversaryDate={workAnniversary}
    />
  )
}
